
export function venueHost(host:string,domains:string[]):string|undefined
{
//XXX maybe more convenient to look up domains in DB here too, but I guess this function is a hack anyway.

	/*
		This function is a hacky solution.

		TODO best solution I think is to have a slug for each site + a production domain eg
			domain: thedock.bar
			slug: thedock3
		THEN auto-calculate all testing, dev and build domains - eg
			thedock3-build.ontoit.xyz etc
	*/

	let primary,secondary;

	for (const domain of domains) {
		/* Eg host=profile-build.ontoit.xyz, domain=thedock-build.ontoit.xyz */
		if (domain.endsWith('-build.ontoit.xyz') && host.endsWith('-build.ontoit.xyz'))
			return 'https://'+domain;
		/* Eg host=profile-dev.ontoit.xyz, domain=thedock-dev.ontoit.xyz */
		if (domain.endsWith('-dev.ontoit.xyz') && host.endsWith('-dev.ontoit.xyz'))
			return 'https://'+domain;
		/* Eg host=profile-test.ontoit.xyz, domain=thedock-test.ontoit.xyz */
		if (domain.endsWith('-test.ontoit.xyz') && host.endsWith('-test.ontoit.xyz'))
			return 'https://'+domain;
		/* Eg host=profile.test:8080, domain=thedock.test */
		if (domain.endsWith('.test') && host.endsWith('.test:8080'))
			return 'http://'+domain+':8080';

		/* Eg host=profile.voshub.com, domain=thedock.bar */

		if (domain.endsWith('.ontoit.xyz'))
			secondary = 'https://'+domain;
		else if (domain.endsWith('.venueonlineservices.app'))
			secondary = 'https://'+domain;
		else if (!domain.endsWith('.test'))
			primary =  'https://'+domain;
	}
	return primary ?? secondary;
}

